import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=5467ec6e&scoped=true&"
import script from "./classifyList.vue?vue&type=script&lang=js&"
export * from "./classifyList.vue?vue&type=script&lang=js&"
import style0 from "./classifyList.vue?vue&type=style&index=0&id=5467ec6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467ec6e",
  null
  
)

export default component.exports